<script>
  import { tick } from "svelte";
  import { ButtonV2, CardV2, TextField, Snackbar } from "$lib";
  import { _ } from "$helpers/i18n.js";
  import { calculatePrice, FormatNumber } from "../../../helpers/calculator";
  import { globalStore } from "../../store/globalStore";

  const { country } = globalStore;

  let totalCost = null;
  let revenueDesired = null;
  let result = null;

  $: totalCost, revenueDesired, (result = null);

  let resultEl;

  let showSnackbar = false;
  let snackbarMessage = "";

  async function calculate() {
    // Resetear snackbar
    showSnackbar = false;

    // Validación de valores positivos
    if (totalCost < 1 || revenueDesired < 1) {
      snackbarMessage = $_("snackbar.commons.positive_values");
      showSnackbar = true;
      return;
    }

    result = calculatePrice(totalCost, revenueDesired, $country).priceSale;

    if ($country === "pe" && typeof fbq === "function") {
      fbq("trackCustom", "CalculatePrice", {
        country: "pe",
        source: "calculator",
        page: "prices"
      });
    }

    await tick();
    resultEl?.scrollIntoView({ behavior: "smooth", block: "centnearester" });
  }
</script>

<CardV2 variant="outlined">
  <div on:keydown={(event) => event.key == '-' && event.preventDefault()}>
    <p>{$_("prices.calculation.first_input")}</p>
    <TextField
      placeholder="0"
      leadingText={$_("common.currency_symbol")}
      bind:value={totalCost}
      type="number"
      step="0.01"
      min={0}
      testId="priceAcquisitionCost"
    />
  </div>
  <div on:keydown={(event) => event.key == '-' && event.preventDefault()}>
    <p>{$_("prices.calculation.second_input")}</p>
    <TextField
      placeholder="0"
      leadingText="%"
      bind:value={revenueDesired}
      type="number"
      step="0.01"
      min={0}
      testId="pricePercentageDesired"
    />
  </div>
  <ButtonV2
    variant="primary"
    class="btn-principal"
    on:click={calculate}
    disabled={!totalCost || !revenueDesired}
    dataTrack="calculate_prices"
  >
    {$_("common.calculate_button")}
  </ButtonV2>

  {#if result != null}
    <div class="result-static" data-testid="priceCalculationResult" bind:this={resultEl}>
      <p>{$_("prices.calculation.result")}</p>
      {FormatNumber($country, result)}
    </div>
  {/if}

  {#if showSnackbar}
    <Snackbar
      variant="warning"
      visible={showSnackbar}
      message={snackbarMessage}
      on:close={() => (showSnackbar = false)}
    />
  {/if}
</CardV2>
